var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"Select state"},on:{"change":_vm.handleChange},model:{value:(_vm.selectedState),callback:function ($$v) {_vm.selectedState=$$v},expression:"selectedState"}},_vm._l((_vm.states),function(state){return _c('el-option',{key:state.name,attrs:{"label":state.name,"value":state.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }